import type { IClientDetailedInfoApi } from '@/pages/ClientInfo/types/client.types';
import type { IClientApi } from '@/pages/Clients/types/clients.types';

import { ApiConnector } from './api.connector';

class ClientApi extends ApiConnector {
  getClients(params: IGetClientsParams): Promise<IClientApi[]> {
    return this.call({ path: 'clients', params });
  }

  getClientById(id: string): Promise<IClientDetailedInfoApi> {
    return this.call({ path: `clients/${id}` });
  }
}

export const clientApi = new ClientApi();

interface IGetClientsParams {
  personalId: string;
}
